import { Debts, FormattedDebts, getFormattedDebts } from "./transform";
import { mergeFormattedDebts } from "./mergeFormattedDebts";

export type DebtsPullingResolvedResult =
  | { kind: "complete"; debts: FormattedDebts[] }
  | { kind: "partial"; debts: FormattedDebts[]; continuePolling: true }
  | { kind: "retry"; continuePolling: true }
  | { kind: "fail"; debts: FormattedDebts[] };

export interface ResolveDebtsPullingResultInput {
  success: boolean;
  code?: string | Debts[];
  partialPassages?: Debts[];
  existingDebts: FormattedDebts[];
}

export function resolveDebtsPullingResult({
  success,
  code,
  partialPassages,
  existingDebts,
}: ResolveDebtsPullingResultInput): DebtsPullingResolvedResult {
  if (success) {
    const incoming = getFormattedDebts((code as Debts[]) || []);
    return { kind: "complete", debts: incoming };
  }

  if (code === "again") {
    const passages = Array.isArray(partialPassages) ? partialPassages : [];
    if (passages.length === 0) {
      return { kind: "retry", continuePolling: true };
    }

    const incoming = getFormattedDebts(passages);
    return {
      kind: "partial",
      debts: mergeFormattedDebts(existingDebts, incoming),
      continuePolling: true,
    };
  }

  return { kind: "fail", debts: [] };
}
